import mockDevicesData from "./mockDevicesData"
import plansConstants from "./plans"
import realEstate from "./real-estate"

export default {
    plans:  {
        [plansConstants.PLANS_IDS.PROPERTY_SAVE]: {
            id: plansConstants.PLANS_IDS.PROPERTY_SAVE,
            description: 'Our starter plan covering home systems and select appliances'
        },
        [plansConstants.PLANS_IDS.PROPERTY_DELUXE]: {
            id: plansConstants.PLANS_IDS.PROPERTY_DELUXE,
            description: 'Our standard home plan covering systems & select appliances with premium options'
        },
        [plansConstants.PLANS_IDS.PROPERTY_PREMIERE]: {
            id: plansConstants.PLANS_IDS.PROPERTY_PREMIERE,
            description: 'Our most comprehensive plan with full appliance & system coverage as well as premium options',
            popular: true
        }
    },
    devices_additional_info: realEstate.devices_additional_info,
    mocksData: {
        ...mockDevicesData,
        devicesGroups: {
            [plansConstants.PLANS_IDS.PROPERTY_SAVE]: mockDevicesData.devicesGroups[plansConstants.PLANS_IDS.HOME_SAVE],
            [plansConstants.PLANS_IDS.PROPERTY_DELUXE]: mockDevicesData.devicesGroups[plansConstants.PLANS_IDS.HOME_DELUXE],
            [plansConstants.PLANS_IDS.PROPERTY_PREMIERE]: mockDevicesData.devicesGroups[plansConstants.PLANS_IDS.HOME_PREMIERE]
        }

    }
}